// extracted by mini-css-extract-plugin
export default {"Image":"half_Image__2xvUm"};